module.exports = __webpack_public_path__ + "img/jhqs1.851c91dd.png";